import React from "react";
import clsx from "clsx";
import { useRequest } from "../../../../../../shared/hooks/useRequest";
import { Text, Spinner } from "@merge-api/merge-javascript-shared";
import { Destination } from "../../../../../../../models/Entities";
import DestinationList from "./components/DestinationList";
import { MergeLinkNavButtons } from "../../../../../../common/MergeLinkDialog/components";

type DestinationStepProps = {
  className?: string;
  onClose: () => void;
  onDestinationSelect: (destination: Destination) => void;
};

const DestinationStep = ({ className, onClose, onDestinationSelect }: DestinationStepProps) => {
  const { data: destinations, loading } = useRequest<Destination[]>({
    path: "/destinations/get-destinations",
    errorText: "Failed to load destinations! Please try again.",
  });

  return (
    <div className={clsx("flex flex-col h-full mt-5", className)}>
      {/* X Button */}
      <MergeLinkNavButtons onClose={onClose} />

      {/* Header */}
      <Text variant="h3" className="mt-3 px-5">
        Select integration
      </Text>

      {/* Integerations */}
      {loading || !destinations ? (
        <div className="flex justify-center items-center h-full">
          <Spinner size="md" />
        </div>
      ) : (
        <DestinationList destinations={destinations} onDestinationSelect={onDestinationSelect} />
      )}
    </div>
  );
};

export default DestinationStep;
